/* 
This class checks for the expiry of jwt token and shows a prompt to the user if the token is about to expire,
based on the users response to the prompt action is taken to either increase the validity of the token or to log the user out
*/

import { environment } from 'src/environments/environment';
import jwt_decode from 'jwt-decode';
import { Injectable } from '@angular/core';
import { UserData } from './userData';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export default class SessionExpiry {
    sessionInterval;
    timerInterval;
    AUTH_SERVER_ADDRESS;
    expiryPromptCheckpoint;

    constructor(private userData: UserData, private router: Router) {
        this.AUTH_SERVER_ADDRESS = environment.apiUrl;
        this.expiryPromptCheckpoint = 5 * 60;
    }

    startCheck() {
        this.sessionInterval = setInterval(async () => {
            await this.checkSessionExpiry();
        }, 1000);
    }

    stopCheck() {
        clearInterval(this.sessionInterval);
    }

    async checkSessionExpiry() {
        const accessToken = await this.userData.getAccessToken();
        if (accessToken) {
            const decodedToken: any = jwt_decode(accessToken);
            const timeToExpiry = decodedToken.exp - this.getCurrentEpochSeconds();

            if (
                timeToExpiry > this.expiryPromptCheckpoint &&
                document.querySelector('#promptBox-backCover')
            ) {
                document.querySelector('#promptBox-backCover')?.remove();
                this.stopTimer();
            } else if (timeToExpiry <= 0) {
                await this.logout('abrupt close');
            } else if (
                timeToExpiry <= this.expiryPromptCheckpoint &&
                !document.querySelector('#promptBox-backCover')
            ) {
                this.promptUser(
                    'Your session will Expire in <span id="expiry-timer">5m 00s</span>.<br />Would you like to Continue?',
                );
                this.startTimer(decodedToken);
                if (window['openedIdeWindow']) {
                    window['openedIdeWindow'].postMessage(
                        {
                            type: 'save',
                        },
                        '*',
                    );
                }
            }
        } else {
            if (location.pathname !== '/login') {
                await this.logout('abrupt close');
            }
        }
    }

    getCurrentEpochSeconds() {
        return Math.round(new Date().getTime() / 1000);
    }

    startTimer(decodedToken) {
        this.timerInterval = setInterval(() => {
            const timeToExpiry = decodedToken.exp - this.getCurrentEpochSeconds();
            const minutes = Math.floor(timeToExpiry / 60);
            const seconds = timeToExpiry - minutes * 60;

            const timerDisplay = document.querySelector('#expiry-timer');
            timerDisplay.textContent = `${minutes}m ${seconds}s`;
        }, 1000);
    }

    stopTimer() {
        clearInterval(this.timerInterval);
    }

    promptUser(promptMessage) {
        const backCover = document.createElement('div');
        backCover.className = 'promptBox-backCover';
        backCover.id = 'promptBox-backCover';

        const promptBox = document.createElement('div');
        promptBox.classList.add('prompt-box');
        promptBox.classList.add('card-body');
        promptBox.classList.add('ms-3');

        const message = document.createElement('div');
        message.classList.add('promptBox-message');
        message.innerHTML = promptMessage;

        const yesButton = document.createElement('button');
        yesButton.textContent = 'Yes';
        yesButton.classList.add('yes-button');
        yesButton.classList.add('option-button');
        yesButton.classList.add('btn');
        yesButton.classList.add('rounded-pill');
        yesButton.classList.add('w-50');
        yesButton.classList.add('btn-primary');
        yesButton.onclick = async (event) => {
            await this.updateAuthTokenExpiry();
            document.querySelector('.promptBox-backCover').remove();
            this.stopTimer();
        };

        const noButton = document.createElement('button');
        noButton.textContent = 'No';
        noButton.classList.add('no-button');
        noButton.classList.add('option-button');
        noButton.classList.add('btn');
        noButton.classList.add('rounded-pill');
        noButton.classList.add('w-50');
        noButton.classList.add('btn-danger');
        noButton.onclick = (event) => {
            this.logout('close');
        };

        const buttonOptions = document.createElement('div');
        buttonOptions.className = 'promptBox-button-list';
        buttonOptions.appendChild(yesButton);
        buttonOptions.appendChild(noButton);

        promptBox.appendChild(message);
        promptBox.appendChild(buttonOptions);

        backCover.appendChild(promptBox);

        const app = document.querySelector('app-root');
        app.appendChild(backCover);
    }

    async logout(type) {
        document.querySelector('.promptBox-backCover')?.remove();

        if (window['openedIdeWindow']) {
            window['openedIdeWindow'].postMessage(
                {
                    type: type,
                },
                '*',
            );
        }

        await this.userData.remove();
        await this.router.navigate(['/']);
        location.reload();
    }

    async updateAuthTokenExpiry() {
        try {
            const accessToken = await this.userData.getAccessToken();

            let response = await fetch(`${this.AUTH_SERVER_ADDRESS}updateToken?api=core`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    token: accessToken,
                }),
            });

            if (response.status === 200) {
                let result = await response.json();
                this.userData.setAccessToken(result.updatedToken);
            }
        } catch (err) {
            console.log(err);
        }
    }
}

window.addEventListener('beforeunload', function (e) {
    // e.preventDefault(); commented out to stop popup on
    if (window['openedIdeWindow']) {
        window['openedIdeWindow'].postMessage(
            {
                type: 'close',
            },
            '*',
        );
    }
    // delete e['returnValue'];
});
